"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GatsbyImage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _core = require("./core");

var GatsbyImage = function GatsbyImage(_ref) {
  var _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit,
      _ref$objectPosition = _ref.objectPosition,
      objectPosition = _ref$objectPosition === void 0 ? '50% 50%' : _ref$objectPosition,
      imgStyle = _ref.imgStyle,
      props = (0, _objectWithoutProperties2.default)(_ref, ["objectFit", "objectPosition", "imgStyle"]);
  return _react.default.createElement(_core.Image, (0, _extends2.default)({
    as: _gatsbyImage.default
  }, props, {
    imgStyle: (0, _objectSpread2.default)({}, imgStyle, {
      objectFit: objectFit,
      objectPosition: objectPosition,
      fontFamily: "\"object-fit: ".concat(objectFit, "; object-position: ").concat(objectPosition, "\"")
    })
  }));
};

exports.GatsbyImage = GatsbyImage;